import { BookingSearchListItem } from '../../Bookings/Types/bookingSearchTypes';
import { Booking } from '../../Shared/Types/bookingTypes';
import {
  ReservationBookingLookupOption,
  ReservationSelectedBookingContext,
} from '../Types/reservationBookingContext.types';

type BookingLookupSource =
  | Pick<Booking, 'id' | 'offerName' | 'bookingDateFrom' | 'bookingDateTo' | 'price'>
  | Pick<BookingSearchListItem, 'id' | 'offerName' | 'bookingDateFrom' | 'bookingDateTo' | 'price'>
  | ReservationSelectedBookingContext;

const formatBookingLabel = ({
  id,
  offerName,
  bookingDateFrom,
  bookingDateTo,
}: Pick<BookingLookupSource, 'id' | 'offerName' | 'bookingDateFrom' | 'bookingDateTo'>): string => {
  const bookingTitle = offerName?.trim() ? offerName : `Rezerwacja #${id}`;
  const hasDateRange = Boolean(bookingDateFrom) && Boolean(bookingDateTo);

  if (!hasDateRange) {
    return bookingTitle;
  }

  return `${bookingTitle} >>> ${bookingDateFrom} - ${bookingDateTo}`;
};

const formatBookingDescription = ({ id, price }: Pick<BookingLookupSource, 'id' | 'price'>): string => {
  return `ID: ${id} | Cena: ${price} zł`;
};

export const mapBookingToReservationLookupOption = (
  booking: BookingLookupSource
): ReservationBookingLookupOption => ({
  value: booking.id,
  label: formatBookingLabel(booking),
  description: formatBookingDescription(booking),
});
